export default {
    fullscreen: false
};
